import {
  addCSSColorClassesToHTML,
  addCSSVariablesToHTML,
  convertRecordToClassNames,
  convertRecordToCSSVariables,
  getManifestVar,
  revertCSSVariable,
  updateCSSColorVariable,
} from "manifest-core/utils/cssVariables";

// NOTE: We want to convert the values back to hex to avoid any transparency issues
const ColorValues = {
  // Globals
  background: getManifestVar("cream"),

  coco: `rgba(46, 45, 41, 1)`,
  coco05: `rgba(46, 45, 41, 0.05)`,
  coco1: `rgba(46, 45, 41, 0.1)`,
  coco3: `rgba(46, 45, 41, 0.3)`,
  coco5: `rgba(46, 45, 41, 0.5)`,
  coco7: `rgba(46, 45, 41, 0.7)`,
  coco9: `rgba(46, 45, 41, 0.9)`,

  orange: `rgba(255, 232, 200, 1)`,
  orange3: `rgba(255, 232, 200, 0.3)`,
  orange5: `rgba(255, 232, 200, 0.5)`,
  orange6: `rgba(255, 232, 200, 0.6)`,
  orange7: `rgba(255, 232, 200, 0.7)`,
  orange9: `rgba(255, 232, 200, 0.9)`,

  // MINT
  mint: `rgba(59, 150, 139, 1)`,
  mint1: `rgba(59, 150, 139, 0.1)`,
  mint3: `rgba(59, 150, 139, 0.3)`,
  mint5: `rgba(59, 150, 139, 0.5)`,
  mint7: `rgba(59, 150, 139, 0.7)`,
  mint9: `rgba(59, 150, 139, 0.9)`,

  // CHERRY
  cherry: `rgba(232, 61, 61, 1)`,
  cherry1: `rgba(232, 61, 61, 0.1)`,
  cherry3: `rgba(232, 61, 61, 0.3)`,
  cherry5: `rgba(232, 61, 61, 0.5)`,
  cherry7: `rgba(232, 61, 61, 0.7)`,
  cherry9: `rgba(232, 61, 61, 0.9)`,

  // CREAM
  cream: `rgba(255, 246, 239, 1)`,

  // SUGAR
  sugar: `rgba(255, 255, 255, 1)`,
};

const ColorVariables = convertRecordToCSSVariables(ColorValues);
const ColorClassNames = convertRecordToClassNames(ColorValues);
const updateCSSColor = updateCSSColorVariable(ColorValues);
const revertCSSColor = revertCSSVariable(ColorValues);
addCSSVariablesToHTML(ColorValues);
addCSSColorClassesToHTML(ColorValues);

export { ColorValues, ColorClassNames, ColorVariables, updateCSSColor, revertCSSColor };
